import React, {useEffect} from 'react'
import Redirecting from '../redirecting'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '@/state/auth'
import {shallow} from 'zustand/shallow'

const SessionExpired = ({isNavbarCollapsed}) => {
  const navigate = useNavigate()
  const logout = useAuth(state => state.logout, shallow)

  useEffect(() => {
    setTimeout(() => {
      logout()
      navigate('/login')
    }, 1250)
  }, [])

  return (
    <div id="content" className={`${isNavbarCollapsed ? 'is-navbar-collapsed' : 'is-navbar-expanded'}`}>
      <Redirecting
        path="/login"
        title="Session expired"
        description="Your session has expired and you require to login again."
        icon="fa-user-clock"
      />
    </div>
  )
}

export default SessionExpired
